
import { defineComponent, toRefs,ref } from "vue";
import useWrapper from "./useChangePassword"
// import { useRoute } from "vue-router";
export default defineComponent({
  name: "",
  components: {},
  setup() {
    //*********** definning variables start **********//
    const {rawData,submitForm} = useWrapper()
    const ruleForm = ref<HTMLElement | null>(null);
    //*********** definning variables end **********//
    //*********** initData start **********//
    //*********** initData end **********//
    //*********** format start **********//
    //*********** format end **********//
    //*********** Data FUN start **********//
    //*********** Data FUN end **********//
    //*********** DOM FUN start **********//
    //*********** DOM FUN end **********//
    return {
      ...toRefs(rawData),ruleForm,submitForm
    }
  },
});
